import { actions as formActions } from 'react-redux-form'
import isObject from 'lodash/isObject'

class FilterHandler {
  constructor(filter) {
    this.filter = filter
  }

  /**
   * For the given filter type, we'll set the field on the form that was passed in
   * @param searchFilterFormName The form name to set the object on
   * @returns {ModelAction} A dispatchable formAction change event
   */
  setFormValue = searchFilterFormName => {
    // console.log("Setting for", this.filter.id, this.filter)
    return formActions.change(
      `${searchFilterFormName}.${this.filter.id}`,
      this.filter.value
    )
  }

  /**
   * test if the parameter should be set, usually in checking the min/max value or other
   * default state vs. the value
   * @param value the value to check
   * @param urlSearchParams the urlSearchParams that have been set
   */
  shouldSetParam = (value, urlSearchParams) => {
    const toSet = !this.isResponseEmpty(value)

    console.log(`Checking ${value} -- should set -- ${toSet}`)

    return toSet
  }

  /**
   * Update the given URLSearchParams object with the appropriate representation of the extracted value
   * @param value
   * @param urlSearchParams a URLSearchParams object
   */
  updateSearchParams = (value, key, urlSearchParams) => {
    const updateParam = (v, shouldAppend = true) => {
      if (this.shouldSetParam(v, urlSearchParams)) {
        shouldAppend ? urlSearchParams.append(key, v) : urlSearchParams.set(key, v)
      }
    }

    if (Array.isArray(value)) {
      console.log('Array values: ', key, value)
      value.forEach(k2 => {
        if (isObject(k2)) {
          if (isObject(k2) && k2[key]) {
            console.log('Was object, found', k2, key)
            updateParam(k2[key])
          } else {
            Object.keys(k2).forEach(k3 => {
              console.log('OBJECT KEYS', k3, k2, k2[k3], key)

              if (k2[k3]) {
                updateParam(k3)
              }
            })
            console.log('Was object, found', k2, key)
          }
        } else {
          updateParam(k2)
        }
      })
    } else if (isObject(value)) {
      console.log('Object values: ', key, value)
      const sub = value

      if (key in sub) {
        //handle simpleselect
        console.log('APPENDING OBJECT FROM sub[k]', sub[key])
        updateParam(sub[key])
      } else {
        console.log('NOT FOUND IN OBJECT, LOOKOING AT KEYS FOR ', key, value)
        Object.keys(sub)
          .filter(v => sub[v] === true)
          .forEach(k2 => {
            console.log('APPENDING OBJECT FROM KEYS OF sub', k2, sub)
            updateParam(k2)
          })
      }
    } else {
      console.log('Regular value: ', key, value)
      updateParam(value, false)
    }
  }

  isResponseEmpty = value => {
    return value === '__'
  }
}

export { FilterHandler }
